<section class="servicios-section">

  <div class="servicios-container">

    <!-- TÍTULO PRINCIPAL -->
    <h2>ADMINISTRACIÓN ESCOLAR.</h2>


    <!-- OBJETIVO -->
    <h4>■ OBJETIVO</h4>

    <p class="objetivo">
      Coordinar y garantizar la correcta gestión de los servicios escolares
      y apoyos estudiantiles, conforme a la normatividad vigente, asegurando
      transparencia, legalidad y equidad en beneficio de la comunidad estudiantil.
    </p>


    <hr>


    <!-- FUNCIONES CLAVE -->
    <h3 class="titulo-funciones">Funciones clave</h3>


    <!-- LISTA PRINCIPAL -->
    <ol class="lista-funciones">

      <!-- 1. PROCESOS ESCOLARES -->
      <li class="funcion-principal">

        <strong>Procesos escolares</strong>

        <ul>
          <li>Inscripción, cambios de carrera y traslados de estudiantes.</li>
          <li>Convalidaciones y equivalencias de programas de estudio.</li>
          <li>Elaboración de los reportes estadísticos institucionales.</li>
          <li>Credencialización estudiantil.</li>
          <li>Aseguramiento Estudiantil (Facultativo y Accidentes Escolares).</li>
        </ul>

      </li>


      <!-- 2. GESTIÓN DOCUMENTAL -->
      <li class="funcion-principal">

        <strong>Gestión documental y certificación</strong>

        <ul>
          <li>Solicitud de constancias, Kardex, justificaciones, entre otros.</li>
          <li>Expedición de certificados, títulos y grados académicos.</li>
          <li>Registro y autenticación de documentos académicos.</li>
          <li>Registro y resguardo de los expedientes físicos estudiantiles.</li>
        </ul>

      </li>


      <!-- 3. APOYO A ESTUDIANTES -->
      <li class="funcion-principal">

        <strong>Apoyo a estudiantes</strong>

        <ul>
          <li>Gestión de becas, estímulos y apoyos ante los sectores público y privado.</li>
          <li>Orientación y atención a estudiantes en los diferentes servicios escolares.</li>
          <li>Seguimiento de solicitudes y trámites estudiantiles.</li>
        </ul>

      </li>

    </ol>


    <hr>

      <h2 class="titulo-drive">CONVOCATORIAS DE BECAS 2026</h2>

        <!-- GOOGLE DRIVE -->
      <div class="drive-container">

        <iframe
          src="https://drive.google.com/embeddedfolderview?id=1rjdQJ2wyK9YRigP4HwHuz2Q3C4lrpGdZ"
          frameborder="0">
        </iframe>

      </div>

      <hr>

      <!-- MEDIOS DE CONTACTO -->
      <div class="contacto-container">

        <h2>Medios de contacto:</h2>

        <p>
          <strong>Correo electrónico institucional:</strong>
          <a href="mailto:serviciosescolares@itsescarcega.edu.mx"> serviciosescolares@itsescarcega.edu.mx</a>
        </p>

        <p>
          <strong>Teléfono:</strong>
          vía llamadas y mensajes por WhatsApp:
          <a href="tel:9821250277"> 9821250277 </a>
        </p>

      </div>


    <hr>



  </div>

</section>